import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillSaveInitiated.meta';

export type SkillSaveSource = 'suggestion' | 'bookmark_fixed' | 'bookmark_message';

export type UseTrackSkillSaveInitiatedParams = {
  source: SkillSaveSource;
};

export const useTrackSkillSaveInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillSaveInitiated = useCallback(
    (params: UseTrackSkillSaveInitiatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillSaveInitiated };
};
